import React, { useState } from 'react';
import ProjectLightbox from '../../components/projectLightbox';
import projectImages from '../data/projectImages';

const ImgGallery = () => {
  const [openFolder, setOpenFolder] = useState(null);

  return (
    <div className="gallery-container m-10 mt-10">
      <div className="grid md:grid-cols-4 gap-10 mt-10">
        {Object.keys(projectImages).map((folder, index) => (
          <div key={index} className="aspect-w-1 aspect-h-1">
            <img
              className="cursor-pointer object-cover object-center w-full h-full transform transition-transform duration-300 hover:scale-105"
              src={`${projectImages[folder][0]}`}
              onError={(e) => { e.target.src = `${projectImages[folder][1]}`; }}
              alt={`Project ${folder}`}
              onClick={() => setOpenFolder(folder)}
            />
          </div>
        ))}
      </div>
      <ProjectLightbox
        images={openFolder ? projectImages[openFolder] : null}
        onClose={() => setOpenFolder(null)}
      />
    </div>
  );
};

export default ImgGallery;
